import { render, staticRenderFns } from "./EstudiosTable.vue?vue&type=template&id=e3e6ef98&scoped=true"
import script from "./EstudiosTable.vue?vue&type=script&lang=js"
export * from "./EstudiosTable.vue?vue&type=script&lang=js"
import style0 from "./EstudiosTable.vue?vue&type=style&index=0&id=e3e6ef98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e6ef98",
  null
  
)

export default component.exports